import { render, staticRenderFns } from "./ZuTable.vue?vue&type=template&id=d557770a&scoped=true"
import script from "./ZuTable.vue?vue&type=script&lang=js"
export * from "./ZuTable.vue?vue&type=script&lang=js"
import style0 from "./ZuTable.vue?vue&type=style&index=0&id=d557770a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d557770a",
  null
  
)

export default component.exports